import { useState } from 'react';
import * as S from './styles'

export const Jobs = () => {
  const [sending, setSending] = useState(false);

  // 👇 novo: estado para o arquivo e o nome exibido
  const [resumeFile, setResumeFile] = useState(null);
  const [fileName, setFileName] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    setSending(true);

    // Exemplo: como você enviaria depois (FormData)
    // const data = new FormData(e.currentTarget);
    // data.append('resume', resumeFile);

    setTimeout(() => {
      setSending(false);
      e.currentTarget.reset();
      setResumeFile(null);
      setFileName('');
      alert('Mensagem enviada! (demo)');
    }, 800);
  }

  // 👇 novo: atualiza nome ao escolher arquivo
  function handleFileChange(e) {
    const file = e.target.files?.[0];
    if (file) {
      setResumeFile(file);
      setFileName(file.name);
    }
  }

  return (
    // <S.Wrapper>
    //   <S.Form onSubmit={handleSubmit} noValidate encType="multipart/form-data">
    //     <S.Field>
    //       <label htmlFor="name">Nome</label>
    //       <S.Input id="name" name="name" required />
    //     </S.Field>

    //     <S.Field>
    //       <label htmlFor="email">Email</label>
    //       <S.Input id="email" name="email" type="email" inputMode="email" required />
    //     </S.Field>

    //     <S.Field>
    //       <label htmlFor="phone">Telefone</label>
    //       <S.Input id="phone" name="phone" type="tel" inputMode="tel" />
    //     </S.Field>

    //     <S.Field>
    //       <label htmlFor="resume">Anexe seu currículo</label>

    //       <S.FileRow>
    //         <S.FileName
    //           type="text"
    //           value={fileName}
    //           placeholder=""
    //           readOnly
    //           aria-readonly="true"
    //         />

    //         <input
    //           id="resume"
    //           name="resume"
    //           type="file"
    //           accept=".pdf,.doc,.docx,.odt,.rtf"
    //           onChange={handleFileChange}
    //           style={{ display: 'none' }}
    //         />

    //         <S.FileButtonBox>
    //           <S.FileButton htmlFor="resume">
    //             Anexar Currículo
    //           </S.FileButton>
    //         </S.FileButtonBox>
    //       </S.FileRow>
    //     </S.Field>

    //     <S.ActionBtn className="ActionBtnBottom" type="submit" disabled={sending}>
    //       {sending ? 'Enviando…' : 'Enviar Mensagem'}
    //     </S.ActionBtn>
    //   </S.Form>
    // </S.Wrapper>

    <S.Wrapper>
      <h2>
        Quer fazer parte da nossa equipe?
      </h2>
      <p>
        Estamos sempre em busca de pessoas talentosas, comprometidas e alinhadas aos nossos valores.
        Se você se identifica com o nosso propósito e quer crescer com a gente, envie seu nome, telefone e currículo para o nosso e-mail.
      </p>

      <S.Email>
        recrutamento@bindflow.com.br
      </S.Email>
    </S.Wrapper>
  )
}
